import React from "react";

const ProgressBar = (props) => {
  const {
    bgcolor,
    completed,
    progressPercentage = null,
    height = 5,
    border = "unset",
    progressBackgroundColor = "transparent",
    color = "white",
    borderRadius = "unset",
    position = "unset",
    right = "unset"
  } = props;

  const containerStyles = {
    height: height,
    width: "100%",
    border: border,
    backgroundColor: progressBackgroundColor,
    display: "flex",
    alignItems: "center",
    borderRadius: borderRadius,
    gap: 5,
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    transition: "width 1s ease-in-out",
    textAlign: "right",
  };

  const percentageStyle = {
    color: color,
    position: position,
    right: right
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}></div>
      {progressPercentage !== null && (
        <span
          className="progress-completed"
          style={percentageStyle}
        >{`${progressPercentage}%`}</span>
      )}
    </div>
  );
};

export default ProgressBar;
